import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a9856ce&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0a9856ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9856ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9856ce')) {
      api.createRecord('0a9856ce', component.options)
    } else {
      api.reload('0a9856ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a9856ce&scoped=true&", function () {
      api.rerender('0a9856ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/openOrders/index.vue"
export default component.exports